import { render, staticRenderFns } from "./SaveResourceModal.vue?vue&type=template&id=33b7bdc4"
import script from "./SaveResourceModal.vue?vue&type=script&lang=js"
export * from "./SaveResourceModal.vue?vue&type=script&lang=js"
import style0 from "./SaveResourceModal.vue?vue&type=style&index=0&id=33b7bdc4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports